import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../../../components/icon/icon.component';
import { HelpLinkDirective } from '../../../components/help-link/help-link.directive';
import { IconButtonBackground, IconButtonComponent } from '../../../components/icon-button/icon-button.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';
import { DataAnalyticsService } from '../../../services/data-analytics/data-analytics.service';
import { DataAnalyticsTaggingConstants } from '../../data-analytics-tagging/data-analytics-tagging.constants';

@Component({
  selector: 'td-wb-toolbar-item-help',
  templateUrl: 'toolbar-item-help.component.html',
  styleUrls: ['toolbar-item-help.component.scss'],
  imports: [
    IconComponent,
    HelpLinkDirective,
    IconButtonComponent,
    AsyncPipe,
    TranslatePipe,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarItemHelpComponent {
  @Input() articleId: string;
  @Input() iconType: 'primary' | 'primary2' | 'inverse' | 'secondary';
  @Input() autoSizeOverride: boolean = true;
  @Input() tdWbIconButtonBackground: IconButtonBackground = 'grey';

  breakpointChanges: Observable<BreakpointState>;

  constructor(private mediaQueryService: MediaQueryService,
              private dataAnalyticsService: DataAnalyticsService) {
    if (this.autoSizeOverride) {
      this.breakpointChanges = this.mediaQueryService.observe(Breakpoint.LT_MD);
    }
  }

  onClick(): void{
    this.dataAnalyticsService.emitEvent(DataAnalyticsTaggingConstants.getLinkClickEventData('tdw:et:help'));
  }
}
